
import { useT } from 'apprise-frontend-core/intl/language'
import { useStable } from 'apprise-frontend-core/utils/function'
import { Button, ButtonProps } from 'apprise-ui/button/button'
import { Preferences, UIPreferencesProvider, usePreferenceProviderContext } from 'apprise-ui/context'
import { PropsWithChildren } from 'react'
import { useAsyncTask } from './utils/asynctask'
import { SaveIcon } from './utils/icons'


export type PreferenceUpdater<T = Preferences> = (_: T) => void

// used to register an implementation of the interface.
export const usePreferencesPlugin = () => {

  const ctx = usePreferenceProviderContext()

  return {

    register: (plugin: Preferences) => ctx.reset(plugin)
  }

}

// provides r/w access to UI preferences, based on a some registered implementation.
export const useUIPreferences = <T extends  Record<string,any>>() => {

  const t = useT()
  const task = useAsyncTask()

  const plugin = usePreferenceProviderContext().get() as Preferences<T>

  const set = task.make(async (updater:PreferenceUpdater<T>) => plugin.set(updater) ).with($=>$.wait(100)).done()

  // saves preferences using a well-typed updater. 
  const SavePreferencesButton = useStable((props: ButtonProps & { updater: PreferenceUpdater<T> }) => {

    const { updater, ...rest } = props

    return <Button tipDelay={1} tip={t('user.save_preferences_tip')} type='link' iconPlacement='left' icon={<SaveIcon />} onClick={() => set(updater)} {...rest}>
      {t('user.save_preferences')}
    </Button>

  })


  const self = { ...plugin, set, SavePreferencesButton }

  return self

}


export const PreferencesProvider = (props: PropsWithChildren) => {

  const { children } = props

  return <UIPreferencesProvider>
    {children}
  </UIPreferencesProvider>
}
